import React, {useState} from 'react'
import { Grid, Icon, Popover, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { grey } from '@mui/material/colors'
import Iconify from '../iconify';



const useStyles = makeStyles(theme => ({
    root:{
        background:'white',
        boxShadow:'0px 4px 8px rgba(102, 102, 102, 0.1)',
        padding:'11px 16px',
        borderRadius:12,
        position:'relative',
        '&:hover':{
            cursor:'pointer'
        }
    },
    icon:{
        //color:blueGrey[500],
        color:theme.palette.primary.main,
        marginTop:4,
        marginLeft:12

    },
    subtitle:{
        paddingLeft:0,
        paddingBottom:0,
        color:theme.palette.primary.main,
        fontSize:12,
        position:'absolute',
        top:-8,
    },
    popper:{
        marginTop:8,
        padding:'8px 4px',
        paddingLeft:0,
        borderRadius:8,
        width:200,
        boxSizing:'border-box',
        overflow:'hidden'
    },
    container:{
        maxHeight:250,
        //background:'red',
        overflowX:'hidden',
        overflowY:'auto',
        
    },
    item:{
        //fontFamily: theme.typography.fontFamily,
        padding:"8px 12px",
        //borderTop:`1px solid ${grey[200]}`,
        '&:hover':{
            cursor:'pointer',
            background:grey[100]
        }
    },
    selected:{
        fontWeight:500
    }
}))

const FilterButton = props => {
    const classes = useStyles()
    const {label, options, selected, onChange, log} = props

    const [anchorEl, setAnchorEl] = useState(null)

    let selectedItem = options.find(el => el.value === selected)


    const onInnerChange = (id) =>{
        setAnchorEl(null)
        onChange(id)
    }
    if(log){
        console.log(`Value: ${selected}`)
        console.log(`Options: ${JSON.stringify(options)}`)
        console.log(`Filter: ${selectedItem}`)
    }

    return(
        <div>
            <Popover classes={{paper:classes.popper}} open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={(e) => setAnchorEl(null)} anchorOrigin={{vertical: 'bottom',horizontal: 'left'}} transformOrigin={{vertical: 'top',horizontal: 'left'}} >
                <div className={classes.container} >
                    {options.map((item,key)=>{
                        return(
                            <div key={key} onClick={() => onInnerChange(item.value)} className={classes.item}>
                                <DisplayColorIdData data={item.label} statusColor={item.colorS}/>
                            </div>
                        )
                    })}
                </div>
            </Popover>
            <div className={classes.root} onClick={(e) => setAnchorEl(e.currentTarget)}>
                <Typography variant='caption' className={classes.subtitle} style={{fontSize:12}}>{label}</Typography>
                <Grid container alignItems='center' spacing={1} wrap='nowrap'>
                    <Grid item >
                        <Typography variant='body1'>{selectedItem ? selectedItem.label : null}</Typography>
                    </Grid>
                    <Grid item>
                        <Iconify icon='material-symbols:keyboard-arrow-down-rounded'/>
                    </Grid>
                </Grid>
            </div>
        </div>
        
    )
}

export default FilterButton

const useDisplayStyles = makeStyles(theme => ({
    icon:{
        color:theme.palette.primary.main,
        //border:`1px solid ${blueGrey[100]}`,
        borderRadius:'50%',
        padding:4    
    },
    status:{
        backgroundColor:'blue',
        borderRadius:'50%',
        width:10,
        height:10,
        margin:'8px 0px'
    }
}))

const DisplayColorIdData = ({statusColor, data, color}) => {

    const classes = useDisplayStyles()

    return(
        <Grid container spacing={1} wrap='nowrap'>
            <Grid item>
                <div className={classes.status} style={{backgroundColor: statusColor ? `${statusColor}` : 'transparent' }}/>
            </Grid>
            <Grid item xs>
                <Typography color={color}>{data??'-'}</Typography>
            </Grid>
        </Grid>
    )
}
